const $navbar = $('#top .header.navbar');
const $navbarCollapse = $navbar.find('.navbar-collapse');

$navbarCollapse.on('show.bs.collapse', () => {
  toggleCollapsedNavbar(true);
}).on('hide.bs.collapse', () => {
  toggleCollapsedNavbar(false);
});

function toggleCollapsedNavbar (status) {
  if (status) {
    $(window).scrollTop(0);
    $('body').addClass('navbar-open');
  } else {
    $('body').removeClass('navbar-open');
  }
  $('body').toggleClass('navbar-open', status);
}

$(document).on('click', event => {
  if (
    !$(event.target).parents('.navbar-header').length &&
    !$(event.target).parents('*[class^="js-"],*[class*=" js-"]').length &&
    $('body').hasClass('navbar-open')
  ) {
    $navbarCollapse.collapse('hide');
  }
});

$navbar.find('.navbar-toggle').on('click', event => {
  $navbarCollapse.collapse(!$('body').hasClass('navbar-open') ? 'show' : 'hide');
});

$(window).on('resize', () => {
  if ($('body').hasClass('navbar-open')) {
    $navbarCollapse.collapse('hide');
  }
});
